// export const baseUrl = "https://moblix.ir";
// export const imagesBaseUrl = "https://moblix.ir";

export const baseUrl = "https://moblix.mehrotech.ir";
export const imagesBaseUrl = "https://moblix.mehrotech.ir";
